import React from 'react';
import { Item } from './Item';
import { Icons } from '@beeline/design-tokens/js/iconfont/icons';
import { Typography } from '../../Typography';
import { Icon } from '../../Icon';
var SEPARATOR_CLASS_NAME = 'lk-ui_breadcrumbs-separator';
export var renderChildren = function (children, isCollapsed, onClick) {
    var _a;
    var childrenLength = children.length;
    var separator = React.createElement(Icon, { size: 'small', iconName: Icons.NavArrowRight });
    if (!isCollapsed) {
        return (_a = children) === null || _a === void 0 ? void 0 : _a.map(function (link, i) {
            return (React.createElement(React.Fragment, { key: i },
                React.createElement(Item, { key: i }, link),
                i < childrenLength - 1 && (React.createElement("li", { className: SEPARATOR_CLASS_NAME, key: "" + i + separator }, separator))));
        });
    }
    return [
        React.createElement(Item, { key: 0 }, children === null || children === void 0 ? void 0 : children[0]),
        React.createElement("li", { className: SEPARATOR_CLASS_NAME, key: 1 }, separator),
        React.createElement(Item, { key: 2, onClick: onClick },
            React.createElement(Typography, { className: 'lk-ui_breadcrumbs-item-text', variant: 'body3' }, "...")),
        React.createElement("li", { className: SEPARATOR_CLASS_NAME, key: 3 }, separator),
        React.createElement(Item, { key: 4 }, children === null || children === void 0 ? void 0 : children[childrenLength - 1]),
    ];
};
